import { render, staticRenderFns } from "./SingleRepository.vue?vue&type=template&id=bf268a1c"
import script from "./SingleRepository.vue?vue&type=script&lang=js"
export * from "./SingleRepository.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports